import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import Selectsearch from "react-select";
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   deleteORTShortGame,
   studentORTShortGame,
   fetchORTShortGame,
   allStudents,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import EditItem from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class chipping extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            listdiv:false,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:'',
            sepmore:1,
            formValues: [{ shot:"", right : "", left : "", short : "", long : "", area:"", contact:"", putt:"", missedgreen : "0", process:"0", disright:"", disleft:"", disshort:"", dislong:"", disradio:""}],
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

   UNSAFE_componentWillMount() {
      this.props.allStudents();
	}

   onAddSession() {
		this.setState({
         viewdiv:false,
         listdiv:false,
         editdiv:false,
         adddiv:true,
      });
   } 
      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         viewdiv:true,
         listdiv:false,
       });
	}
   
   selstudent = (evt) =>{
      var stdid=evt.value;
      this.setState({ student:stdid });
      var start='';
      var end='';
      this.props.studentORTShortGame(stdid, start, end).then((data) => {   
         
         this.setState({ 
             listdiv:true,               
             adddiv:false,
             editdiv:false,
         });

     });
   }


   editAssessment(assmval){
        
      var id=assmval.grc_userID;
      var date=assmval.grc_date;
        
        this.props.fetchORTShortGame(id, date).then((data) => {   
            var resdata=data.data;
            var troptobj=[]; 
            {resdata.map((teamval) => (   

               troptobj.push({
                  shot:teamval.grc_shot,
                  right: teamval.grc_right,
                  left: teamval.grc_left,
                  short: teamval.grc_short,
                  long: teamval.grc_long,
                  contact:teamval.grc_contact,
                  putt:teamval.grc_putt,
                  area: teamval.grc_area,
                  missedgreen:teamval.grc_outside,
                  process:teamval.grc_process,
                  disright:teamval.grc_right==0 ? 0 : 1, 
                  disleft:teamval.grc_left==0 ? 0 : 1, 
                  disshort:teamval.grc_short==0 ? 0 : 1, 
                  dislong:teamval.grc_long==0 ? 0 : 1, 
                  disradio:teamval.grc_process,  
               })
            ))} 
            this.setState({ 
               seldate:resdata[0].grc_date, 
               student:resdata[0].grc_userID,
               formValues:troptobj,
               sepmore:resdata.length
            });

            this.setState({ 
                viewdiv:false,  
                listdiv:false,              
                adddiv:false,
                editdiv:true,
            });

        });
   }

    deleteForm(assmval){
      this.id = assmval.grc_userID;
      this.date = assmval.grc_date;
      this.confirmationDialog.current.openDialog();
    }

   deleteDataPermanent(popupResponse){
      
         if (popupResponse) {
            this.props.deleteORTShortGame(this.id, this.date);
            this.data = ""
         }
   }

   

    render() {
      const { match, studentlists, ortshortgamelist, loading } = this.props;
      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });
      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
      };

      const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
          
      ];
        const tabledata=ortshortgamelist.map((assmntval,idx) => {     
               const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
               const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                  no:idx+1,
                  name: assmntval.student,
                  cdate: assmntval.cdate,
                  action: ebtn,
                  action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>On Range Short Game Random Test | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.onrshortgame" />} match={match} />
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}> 
                        <Label for="Select">Student *</Label> 
                        <FormGroup>   
                           <Label for="Select">Student *</Label>                                           
                           <Selectsearch id="student" name="student" placeholder="Select..." options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                        </FormGroup>
                  </div>
               }                          
               {this.state.listdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Test</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                  <EditItem onClick={this.onBackSection} data={this.state}/>              
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'short game test'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, ortshortgame }) => {
   const { studentlists } = mostlyused;
	const { ortshortgamelist, loading } = ortshortgame;
	return { studentlists, ortshortgamelist, loading };
}

export default connect(mapStateToProps, {

   deleteORTShortGame,
   studentORTShortGame,
   fetchORTShortGame,
   allStudents
})(chipping); 